import Vue from 'vue';

Vue.directive('intersect', {
  inserted,
  unbind,
});

// ////////////////////////////////////////////
function inserted(el, binding) {
  const { value, modifiers = {} } = binding;
  const _options = typeof value === 'object'
    ? value
    : {
      handler: value,
      options: {},
    };
  const { handler, options } = _options;
  const observer = new IntersectionObserver((entries, observer) => {
    if (!el._observe) {
      return;
    }

    if (typeof handler === 'function' && (!modifiers.quiet || el._observe.init)) {
      const isIntersecting = Boolean(entries.find(entry => entry.isIntersecting));

      handler(entries, observer, isIntersecting);
    }

    if (el._observe.init && modifiers.once) {
      unbind(el);
    } else {
      el._observe.init = true;
    }
  }, options);

  el._observe = {
    init: false,
    observer,
  };

  observer.observe(el);
}

function unbind(el) {
  /* istanbul ignore if */
  if (!el._observe) {
    return;
  }

  el._observe.observer.unobserve(el);

  delete el._observe;
}
